import $ from 'jquery';
import Vue from 'vue';
import VueAppHead from '~/src/custom/vue/apps/header-search-bar.js';
import VApp from '~/src/custom/vue/apps/containers/header-search-app.vue';
import * as CONST from '../../common/utils/constants';
import Util from '../../common/utils/ui';
import validationRules from '../../common/utils/validation';

// connect vue component and init app 
Vue.component('app', VApp);
if (document.getElementById('search-typeahead-header-app') !== null) {
    VueAppHead.$mount('#search-typeahead-header-app');
} 

class Layout {
    constructor() {
        this.$body = $('body');
        this.$header = $('.header');
        this.$hiddenHeader = $('.js-top-target');

        this.$nav = $('.nav-wrapper');
        this.$primaryNavItem = $('.primary-nav > li');        
        this.$primaryNavItemLink = $('.primary-nav > li > a');
        this.$primaryNavItemToggleButton = $('.primary-nav > li > button.toggle-button');
        this.$buttonNavItem = $('.header-nav-btns > li');
        this.$buttonNavItemLink = $('.header-nav-btns > li > a');
        this.$navOpenBtn = $('.js-nav-open-btn');
        this.$navCloseBtn = $('.js-nav-close-btn');
        this.$navToggleLabel = $('.js-nav-toggle-label');
        this.$navToggleChildren = $('.js-nav-toggle-children');
        this.$navToggleChildrenButton = $('.js-nav-toggle-children-button');
        this.$navToggleChildrenButtonSR = $('ul.primary-nav > li > button');

        this.$search = $('.js-search');
        this.$searchToggle = $('.js-search-toggle');
        this.$searchClose = $('.js-search-close');
        this.$searchBarClose = $('.typeahead__close');

        this.$searchInput = $('.typeahead__search');

        this.didScroll = false;
        this.lastScrollTop = 0;
        this.delta = 5;

        this.validFooterSignup = true;
        this.firstSignupSubmit = false;
        this.signupSubmitSuccess = false;

        this.$footerAccordionItem = $('.js-footer-accordion > .footer-column-navigation-item--parent:not(.featured) > a');

        this.timer = 0;
        this.$topOfPage = $('#topOfPage');
        this.$skipLink = $('.js-top-target');
        this.$menuButton = $('.js-menu-icon');
        this.$menuIcon = '<svg aria-hidden="true" data-prefix="far" data-icon="bars" class="svg-inline--fa fa-bars fa-w-14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M436 124H12c-6.627 0-12-5.373-12-12V80c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12z"/></svg>';
        this.$closeIcon = '<svg aria-hidden="true" data-prefix="far" data-icon="times" class="svg-inline--fa fa-times fa-w-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"/></svg>';
    }

    init() {
        this.bindEvents();
        this.initFooterNewsletterSignup();
    }

    bindEvents() {
        this.$skipLink.on('keydown', e => {
           if ((e.originalEvent.keyCode || e.keyCode) === 13) {
               $('.js-agent-type').focus();
           }
        });

        this.$navOpenBtn.on('click', e => {
            e.preventDefault();
            this.toggleNav(e);
        });

        this.$navCloseBtn.on('click', e => {
            e.preventDefault();
            this.toggleNav(e);
        });

        this.$navToggleChildren.on('click', e => { this.mobileNavItem(e); });
        this.$navToggleChildrenButton.on('click', e => { this.mobileNavButtons(e); });
        this.$navToggleChildren.on('click keypress', e => { if ((e.keyCode || e.which) === 32 || (e.keyCode || e.which) === 13) { this.mobileNavButtons(e); } });

        this.$searchToggle.on('click', e => { this.toggleSearch(e); });
        this.$searchClose.on('click', e => { this.toggleSearch(e); });
        this.$searchBarClose.on('click', e => { this.toggleSearch(e); });

        $('.header .search').on('click', e => { e.stopPropagation(); });
        $('.sidebar-container-btn').on('click', e => {
            $('.menu-sidebar').slideToggle();
            $(e.currentTarget).toggleClass('active');
        });

        // on menu enter
        this.$primaryNavItemLink.on('focus', e => { this.tabbingNavItemLinkFocus(e); });
        // this.$buttonNavItemLink.on('keydown', e => { this.tabbingNav(e); });
        this.$primaryNavItemToggleButton.on('keydown', e => { this.tabbingToggleButtonNav(e); });        

        this.$footerAccordionItem.on('click', e => {
            e.preventDefault();
            this.footerAccordion(e);
        });

        this.$navToggleChildrenButtonSR.on('click', e => {
            clearTimeout(this.timer);
            if ($('.js-nav-megamenu').hasClass('open')) {
                this.closeSubmenu(e);
            } else {
                $('.js-nav-megamenu').removeClass('open');
                this.openSubmenu(e);
            }
        });

        // open megamenu on hover for desktop
        this.$primaryNavItem.on('mouseover', e => {
            clearTimeout(this.timer);
            $('.js-nav-megamenu').removeClass('open');
            const target = $(e.currentTarget); 
            if (target.children('a').is('a')) {
                const buttonElement = target.children('button');
                buttonElement.attr('aria-expanded', 'true');
            }
            this.openSubmenu(e);
        }).on('mouseleave', e => {
            this.timer = setTimeout(() => {
                this.closeSubmenu(e);
            }, 300);
        });
        this.$buttonNavItem.on('mouseover', e => {
            clearTimeout(this.timer);
            $('.js-nav-megamenu').removeClass('open');

            this.openSubmenu(e);
        }).on('mouseleave', e => {
            this.timer = setTimeout(() => {
                this.closeSubmenu(e);
            }, 300);
        });

        // Hide Header on on scroll down
        $(window).scroll(e => {
            this.didScroll = true;
        });

        $(window).resize(e => {
            if (window.innerWidth >= 992) {
                this.$body.css('padding-top', 0);
                this.$body.removeClass('header-up').removeClass('header-down');
                if ($('.js-nav-open-btn').hasClass('invisible')) {
                    $('div.nav-wrapper').removeAttr('aria-modal');
                    $('div.nav-wrapper').removeAttr('role');
                    $('div.nav-wrapper').removeAttr('aria-label');
                }
            } else if ($('.js-nav-open-btn').hasClass('invisible')) {
                   $('div.nav-wrapper').attr('aria-modal', true);
                   $('div.nav-wrapper').attr('role', 'dialog');
                   $('div.nav-wrapper').attr('aria-label', 'Mobile menu');
            }
        });

        $('.nav-header-utilities > li:last-child > a').addClass('last-focusable-element');
        let firstFocusableElement = $('a.header-logo');
        let lastFocusableElement = $('a.last-focusable-element');

        $(window).on('keydown', (e) => {
            if (e.target.className === 'header-logo' && e.originalEvent.key  === 'Tab' && e.originalEvent.shiftKey) {
                e.preventDefault();
                lastFocusableElement.focus();
            } else if (e.target.className === 'last-focusable-element' && e.originalEvent.key === 'Tab' && !e.originalEvent.shiftKey) {
                e.preventDefault();
                firstFocusableElement.focus();
            }
        });

        setInterval(() => {
            if (this.didScroll && window.innerWidth <= 991) {
                this.headerStickyness();
                this.didScroll = false;
            }
        }, 100);

        // The interval below is regular Launchpad behavior. Keep the code in case it is needed.
        // setInterval(() => {
        // 	if (this.didScroll) {
        // 		this.hasScrolled();
        // 		this.didScroll = false;
        // 	}
        // }, 100);

        //Scrolls back to the top after tabbing through page
        this.$hiddenHeader.focus(() => {
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        });
        //---/ Footer


        // Anchor clicks
        let $root = $('html, body');
        $(document).on('click', 'a[href^="#"]', (event) => {
            event.preventDefault();

            let href = $.attr(event.currentTarget, 'href');
            if (href !== '#') {
                $root.animate({
                    scrollTop: $(href).offset().top - 89
                }, 500);
            }
        });
        //---/ Anchor clicks
    }

    closeSubmenu(e) {
        const target = $(e.currentTarget);                
        $(target).closest('li').find('.js-nav-megamenu').removeClass('open');
        if (target.children('a').is('a')) {
            const buttonElement = target.children('button');
            buttonElement.attr('aria-expanded', 'false');
        }
    }

    headerStickyness() {
        let st = $(window).scrollTop();
        let headerHeight = $('.header').outerHeight();
        let bannerHeight = ($('.js-banner').hasClass('closed') || $('.js-banner') === undefined || $('.js-banner').length === 0) ? 0 : $('.js-banner').outerHeight();

        // Make sure they scroll more than delta
        if (Math.abs(this.lastScrollTop - st) <= this.delta) {
            return;
        }

        // This is necessary so you never see what is "behind" the header.
        if (st > headerHeight) {
            this.$body.css('padding-top', headerHeight);
            this.$body.addClass('header-up');
        } else if (st <= (bannerHeight + 50)) {
            this.$body.css('padding-top', 0);
            this.$body.removeClass('header-up');
        }

        this.lastScrollTop = st;
    }

    // The method below is regular Launchpad behavior. Keep the code in case it is needed.
    // hasScrolled() {
    // 	let st = $(window).scrollTop();
    // 	let headerHeight = $('.header').outerHeight();
    // 	let bannerHeight = ($('.js-banner').hasClass('closed') || $('.js-banner') === undefined || $('.js-banner').length === 0) ? 0 : $('.js-banner').outerHeight();

    // 	// Make sure they scroll more than delta
    // 	if (Math.abs(this.lastScrollTop - st) <= this.delta) {
    // 		return;
    // 	}

    // 	// If they scrolled down and are past the header, add class .header-up.
    // 	// This is necessary so you never see what is "behind" the header.
    // 	if (st > headerHeight) {
    // 		this.$body.css('padding-top', headerHeight);

    // 		if (st > this.lastScrollTop) {
    // 			// Scroll Down
    // 			this.$body.removeClass('header-down').addClass('header-up');
    // 			this.$header.css('top', -headerHeight - 5);
    // 		}
    // 		else if (st + $(window).height() < $(document).height()) {
    // 			// Scroll Up
    // 			this.$body.removeClass('header-up').addClass('header-down');
    // 			this.$header.css('top', 0 - bannerHeight);
    // 		}
    // 	}
    // 	else if (st <= (bannerHeight + 50)) {
    // 		this.$body.css('padding-top', 0);
    // 		this.$header.css('top', 'auto');
    // 		this.$body.removeClass('header-up').removeClass('header-down');
    // 	}

    // 	this.lastScrollTop = st;
    // }

    // clicking on items in mobile nav
    mobileNavItem(e) {
        if (Util.getViewPort() !== CONST.ViewPort.Desktop) {
            e.preventDefault();
            const target = $(e.currentTarget);
            const parent = target.closest('li');
            const controlText = target.text().trim();
            let toggleBtn = parent.children('button:first');
            $(parent).find('> ul').slideToggle();
            //console.log(!!$(target), !!$(parent).hasClass('open'), toggleBtn);
            if ($(target) && $(parent).hasClass('open')) {
                toggleBtn.attr('aria-expanded', 'false');
            } else if ($(target)) {
                toggleBtn.attr('aria-expanded', 'true');
            }
            $(parent).toggleClass('open');
        }
    }

    //clicking on items mobile nav (buttons pay bill/log in).
    mobileNavButtons(e) {
        if ($(e.currentTarget).attr('aria-expanded') === 'true') {
                $(e.currentTarget).attr('aria-expanded', 'false');
            } else {
                $(e.currentTarget).attr('aria-expanded', 'true');
            }
        if (Util.getViewPort() !== CONST.ViewPort.Desktop) {
            e.preventDefault();

            const target = $(e.currentTarget);
            const parent = target.closest('div');
            const mobile = $(`*[data-parent-text="${target.text()}"]`);
            const buttons = parent.closest('div.header-nav-btns');
            $(buttons).children().each((i, el) => {
                const children = $(el).find('>:first-child');
                if ($(el).hasClass('open') && children.text() !== target.text()) {
                    const mobileChildren = $(`*[data-parent-text="${children.text()}"]`);
                    $(mobileChildren).slideToggle();
                    $(el).toggleClass('open');
                }
            });

            $(mobile).slideToggle();
            $(parent).toggleClass('open');
        }
    }

    openSubmenu(e) {
        const target = $(e.currentTarget);        
        $(target).closest('li').find('.js-nav-megamenu').addClass('open');
    }

    tabbingNav(e) {
    }

    tabbingNavItemLinkFocus(e) {
        let target = $(e.currentTarget);        
        let nav = target.parent();
        $('.js-nav-megamenu').removeClass('open');                
    }

    // if user hits enter when tabbing on menu items, open mega menu and set tabbing to children
    tabbingToggleButtonNav(e) {
        let target = $(e.currentTarget);
        // target is the toggle button
        let link = target.next();
        let nav = target.parent();

        if ((e.keyCode === 13 || e.keyCode === 13) && link.hasClass('has-dropdown')) {
            e.preventDefault();
            if ($(target).closest('li').find('.js-nav-megamenu').hasClass('open')) {
                $(target).closest('li').find('.js-nav-megamenu').removeClass('open');
                $(target).attr('aria-expanded', 'false');
            } else {
                $(target).closest('li').find('.js-nav-megamenu').addClass('open');
                $(target).attr('aria-expanded', 'true');
            }                   
        }     
        if (e.shiftKey && (e.keyCode === 9)) {
            $(target).closest('li').find('.js-nav-megamenu').removeClass('open');
            $(target).attr('aria-expanded', 'false');
        }
    }

    // toggle nav on mobile
    toggleNav(e) {
        if ($('.js-nav-open-btn').hasClass('invisible')) {
            $('div.nav-wrapper').removeAttr('aria-modal');
            $('div.nav-wrapper').removeAttr('role');
            $('div.nav-wrapper').removeAttr('aria-label');
        } else {
            $('div.nav-wrapper').attr('aria-modal', true);
            $('div.nav-wrapper').attr('role', 'dialog');
            $('div.nav-wrapper').attr('aria-label', 'Mobile menu');
        }

        $('.js-nav-megamenu').removeAttr('style').closest('li').removeClass('open'); // Open nav with sub menus closed

        $('.js-nav-open-btn').toggleClass('invisible');
        $('.js-nav-open-btn').toggleClass('nav-toggle');
        $('.js-nav-close-btn').toggleClass('hidden');
        $('.js-nav-close-btn').toggleClass('nav-toggle');
        this.$nav.slideToggle().toggleClass('open');
        this.$body.toggleClass('nav-open');
        this.$searchToggle.removeClass('open');
        this.$search.slideUp();
    }

    // toggle search on mobile
    toggleSearch(e) {
        this.$nav.slideUp();

        
        $('.search-toggle.js-search-toggle').attr('');
        $('.nav-megamenu').slideUp();
        this.$body.removeClass('nav-open');

        if ($('.js-nav-open-btn').hasClass('invisible')) {
            $('.js-nav-open-btn').removeClass('invisible');
            $('.js-nav-open-btn').addClass('nav-toggle');
            $('.js-nav-close-btn').addClass('hidden');
            $('.js-nav-close-btn').removeClass('nav-toggle');
        }

        this.$primaryNavItem.removeClass('open');
        this.$buttonNavItem.removeClass('open');

        this.$searchToggle.toggleClass('open');

        if (this.$searchToggle.hasClass('open')) {
            this.$searchToggle.attr('aria-expanded', 'true');
        } else {
            this.$searchToggle.attr('aria-expanded', 'false');
        }

        this.$search.slideToggle();
        setTimeout(() => document.querySelector('.typeahead__search').focus(), 50);
    }

    // Footer Newsletter signup
    initFooterNewsletterSignup() {
        let context = this;

        $('#newsletter-signup-submit').on('click', e => {
            e.preventDefault();
            if (context.doFooterSignupValidation()) {
                grecaptcha.ready(() => {
                  grecaptcha.execute($('g-recaptcha').data('sitekey'), { action: 'footerSubmit' }).then((token) => {
                        $('#g-recaptcha-response').val(token);
                        $('#newsletter-signup-submit').attr('disabled', true);
                        $('#newsletter-signup-submit').addClass('disabled');
                        $('#newsletter-signup-submit').css('pointer-events', 'none');
                        context.submitNewsletterSignup();
                    });
                });
            }
        });
    }

    doFooterSignupValidation() {
        // validate data in reverse verticle order => top most scrollToElement
        this.validFooterSignup = true; // try and make me false
        this.validateEmail();
        this.validateLastName();
        this.validateFirstName();

        if (this.validFooterSignup === false) {
            if (this.firstSignupSubmit === false) {
                this.firstSignupSubmit = true;
                // add new events for better ux post 1st submit : realtime validation msging
                this.eventsAfterSubmitionFail();
            }
            return false;
        }
        return true;
    }

    validateFirstName() {
        let firstName = $('#Footer_FirstName').val();
        if (firstName === undefined || firstName === '') {
            $('.footer-newsletter-signup .col-first-name .field-validation-error-icon').removeClass('hidden');
            $('#Footer_FirstName').attr('aria-invalid', 'true');
            $('#Footer_FirstName').focus();
            $('#Footer_FirstName').addClass('error');
            this.validFooterSignup = false;
        } else {
            $('.footer-newsletter-signup .col-first-name .field-validation-error-icon').addClass('hidden');
            $('#Footer_FirstName').attr('aria-invalid', 'false');
            $('#Footer_FirstName').blur();
            $('#Footer_FirstName').removeClass('error');
        }
    }

    validateLastName() {
        let lastName = $('#Footer_LastName').val();
        if (lastName === undefined || lastName === '') {
            $('.footer-newsletter-signup .col-last-name .field-validation-error-icon').removeClass('hidden');
            $('#Footer_LastName').attr('aria-invalid', 'true');
            $('#Footer_LastName').focus();
            $('#Footer_LastName').addClass('error');
            this.validFooterSignup = false;
        } else {
            $('.footer-newsletter-signup .col-last-name .field-validation-error-icon').addClass('hidden');
            $('#Footer_LastName').attr('aria-invalid', 'false');
            $('#Footer_LastName').blur();
            $('#Footer_LastName').removeClass('error');
        }
    }

    validateEmail() {
        let email = $('#Footer_EmailSignUp');
        if (email.val() === undefined || email.val() === '') {
            $('.footer-newsletter-signup .row-email .field-validation-error-icon').html('<span aria-hidden="true"></span>Please complete all fields to sign up.');
            $('.footer-newsletter-signup .row-email .field-validation-error-icon').removeClass('hidden');
            $('#Footer_EmailSignUp').attr('aria-invalid', 'true');
            $('#Footer_EmailSignUp').focus();
            $('#Footer_EmailSignUp').addClass('error');
            this.validFooterSignup = false;
        } else if (!validationRules.emailValidate(email)) {
            $('.footer-newsletter-signup .row-email .field-validation-error-icon').html('<span aria-hidden="true"></span>Please provide a valid email.');
            $('.footer-newsletter-signup .row-email .field-validation-error-icon').removeClass('hidden');
            $('#Footer_EmailSignUp').attr('aria-invalid', 'true');
            $('#Footer_EmailSignUp').focus();
            $('#Footer_EmailSignUp').addClass('error');
            this.validFooterSignup = false;
        } else {
            $('.footer-newsletter-signup .row-email .field-validation-error-icon').addClass('hidden');
            $('#Footer_EmailSignUp').attr('aria-invalid', 'false');
            $('#Footer_EmailSignUp').blur();
            $('#Footer_EmailSignUp').removeClass('error');
        }
    }

    eventsAfterSubmitionFail() {
        $('#Footer_FirstName').on('keyup', () => this.validateFirstName());
        $('#Footer_LastName').on('keyup', () => this.validateLastName());
        $('#Footer_EmailSignUp').on('keyup', () => this.validateEmail());
    }

    submitNewsletterSignupSuccess(results) {
        // console.log('signup success', results);
        this.signupSubmitSuccess = true;
        $('.footer-newsletter-signup .form-wrapper').addClass('hidden');
        $('.footer-newsletter-signup .form-success').removeClass('hidden');
    }

    submitNewsletterSignupFail(results) {
        $('.asterisk-meaning').text('* '.concat(results.responseJSON.Message));
        this.signupSubmitSuccess = false;
    }

    submitNewsletterSignup() {
        let fName = $('#Footer_FirstName').val();
        let lName = $('#Footer_LastName').val();
        let emailSignup = $('#Footer_EmailSignUp').val();
        let rtoken = $('#g-recaptcha-response').val();
        let data = {
            email: emailSignup,
            firstName: fName,
            lastName: lName,
            token: rtoken
        };

        $.ajax({
            type: 'POST',
            data: JSON.stringify(data),
            contentType: 'application/json; charset=utf-8',
            url: '/api/registration/subscribe',
            success: (results) => this.submitNewsletterSignupSuccess(results),
            error: (results) => this.submitNewsletterSignupFail(results)
        });
    }

    // Footer accordion expand/collapse
    footerAccordion(e) {
        const target = $(e.currentTarget);

        if (Util.getViewPort() !== CONST.ViewPort.Desktop) {
            target.parent().toggleClass('open');
            target.siblings('.footer-column-navigation-sub').slideToggle();
        } else {
            let href = $(target).attr('href');
            window.location = href;
        }
    }
}

export default Layout;